import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { first } from 'rxjs/operators';
import { ProviderLinkService } from '../../core/services';
import { ClientService } from '../../core/services/client.service';
import { Client } from '../../domain/models';
import { AuthPopupService, AuthService } from '../../features/auth/services';
import { Provider } from '../../features/provider/models';
import { BlueBackgroundDirective } from '../../shared/directives';
import { GoogleAnalyticsService } from '../../shared/service/google-analytics.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslocoModule,
        RouterModule,
        MatButtonModule,
        FlexLayoutModule,
        BlueBackgroundDirective
    ]
})
export class HomeComponent implements OnInit {
    client: Client | undefined;

    steps: { icon: string; descriptionKey: string }[] = [
        {
            icon: 'step 1.svg',
            descriptionKey: 'home.step.one'
        },
        {
            icon: 'step 2.svg',
            descriptionKey: 'home.step.two'
        },
        {
            icon: 'step 3.svg',
            descriptionKey: 'home.step.three'
        },
        {
            icon: 'step 4.svg',
            descriptionKey: 'home.step.four'
        }
    ];
    hasProvider: boolean | undefined;
    hasProgram: boolean | undefined;
    introduction: string | undefined;

    constructor(
        private readonly _router: Router,
        private readonly _client: ClientService,
        private readonly _auth: AuthService,
        private readonly _authPopup: AuthPopupService,
        private readonly _route: ActivatedRoute,
        private readonly _providerLink: ProviderLinkService,
        private readonly _transloco: TranslocoService,
        private _googleAnalyticsService: GoogleAnalyticsService
    ) {}

    ngOnInit(): void {
        this._googleAnalyticsService.pageView('Home');
        this._client.latest.subscribe((client) => {
            if (!client) return;
            this.client = client;
            // if (!this.client.isEnabled) return;

            this.introduction = this.client.introductionText;
            this._providerLink.checkForParams(this._route.snapshot.paramMap);
            this.hasProvider = this._providerLink.hasProvider;
            this.hasProgram = this._providerLink.hasPrograms;
            if (this.hasProvider) {
                this._providerLink.provider$?.subscribe((provider) => {
                    if (provider === null || provider === undefined) {
                        this._router.navigate([
                            `${runtimeConfig.clientCode}/home`
                        ]);
                        return;
                    }
                    this.setIntroductionText(provider);
                    this._providerLink.cleanProgramIds(provider);
                });

                // Remove the first step, and reset the icons
                this.steps = [
                    {
                        icon: 'step 2.svg',
                        descriptionKey: 'home.step.two'
                    },
                    {
                        icon: 'step 3.svg',
                        descriptionKey: 'home.step.three'
                    },
                    {
                        icon: 'step 4.svg',
                        descriptionKey: 'home.step.four'
                    }
                ];
            }
        });
    }
    navigateToProgram() {
        this._router.navigateByUrl(`${this.client?.clientCode}/program`);
    }

    startApplication(): void {
        if (this._auth.isSignedIn)
            this._router.navigateByUrl(
                `${this.client?.clientCode}/application`
            );
        else this._authPopup.showAccountCreation();
    }

    private setIntroductionText(provider: Provider | undefined): void {
        if (provider) {
            this._transloco
                .selectTranslate('home.provider-introduction')
                .pipe(first())
                .subscribe(
                    (message) =>
                        (this.introduction = `${message} ${provider.name}.`)
                );
        }
    }
}
